// extracted by mini-css-extract-plugin
export default {"boxComponent":"DashBoardPage_boxComponent__bhUJi"};